'use strict';

angular.module('dekky.forms.themes.inviteUser', [])
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/inviteUser/collection.html',
		'<div ng-init="model = model || []" ng-model="model">' +
			'<div repeat-collection class="panel panel-default" ng-form="childForm">' +
				'<div class="panel-body">' +
					'<div class="form-items">' +
						'<form-row ng-repeat="(key, itemField) in field.childForm.$fields" ng-model="item[key]" ng-model-options="{ updateOn: \'blur\' }" field="itemField"></form-row>' +
						'<p class="form__error" ng-if="childForm.$dirty" ng-messages="childForm.$error" role="alert">' +
							'<span ng-message="uniqueUser">Такой email уже зарегистрирован на сайте</span>' +
							'<span ng-message="required">Заполните все поля</span>' +
						'</p>' +
					'</div>' +
					'<a class="btn-link margin_b_20 right" ng-click="field.doDelete(item, model, $index)">{{ field.buttons.remove }}</a>' +
				'</div>' +
			'</div>' +

			'<div class="form-group">' +
				'<a class="btn-link margin_b_40" ng-click="field.addItem(model)">{{ field.buttons.add }}</a>' +
			'</div>' +
		'</div>'
	);
});
